GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);

  this.fireballCostMultiplier = 100;
  this.freeSpinsCostMultiplier = 200;

  this.fireballActive = false;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this.fireballLivesMax = 0;

  this.isGameModeBonusBuyBase = this.isGameModeBonusBuy;
  this.isGameModeBonusBuy = this.isGameModeBonusBuyDerived;

  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this._inBuyABonus = false;
  this._inEncore = false;
  this._endGame = false;

  // this.loadLanguageFiles = undefined; // delete me when translations are ready
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServer.prototype.isGameModeBonusBuyDerived = function (mode) {
  return mode === "BONUS_BUY_LOW" || mode === "BONUS_BUY_HIGH";
};

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot
      .getGameEventsEmitter()
      .gameReady({ defaultBetValue: this._stake / 100 });
    console.log(
      "Gati Platform: Restore Mode set to " + readyResponse.restoreMode
    );
    // no longer modal
    messageBus.post("game:modal", {});
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === "RESTORE";
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame(
        { stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines },
        self._isRecoveryGame
      );

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      self.addBalanceEventToQueue();
      self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate("common:GameCommitted");
    } else if (readyResponse.restoreMode === "SKIP") {
      const stakeInfo = self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };

      if (self._latestEngineReponse.wager.bets.length) {
        let betData = self._latestEngineReponse.wager.bets[0].betdata;
        let stake = Number(betData.coin * 1000);
        gameData.recoveryStake = stake;

        if (betData.cmd === "LUCKYBET_BUY") {
          gameData.recoveryStake *= gameData.goldenBetMultiplier;
          gameData.goldenBetBtn.setRecovery();
        }
      }

      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      messageBus.postImmediate("common:GameSkipped", stakeInfo);
      self.addBalanceEventToQueue();
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      // Show help page if this is BR license and we are not restoring a game
      let license = gameData.license;
      if (license === "" || license === undefined) {
        license = "default";
      } else {
        license = gameData.license.toUpperCase();
      }

      if (license === "BR") {
        gameData.helpPageScroll.open();
      }
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post("game:modal", {
    reason: "Waiting on Platform",
  });

  informGameReady(this._slotGame);
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_TOP",
    ["playerState"]
  );
};

GatiServerGame.prototype.addStartingPersistenceStateQueue = function () {
  this.persitenceState = {
    playerState: this.defaultPersistanceData,
    initialPlayerState: this.defaultPersistanceData,
    version: 1,
  };
  var message = {};
  message.type = "8bofBB:PersistenceUpdate-UpdateToStarting";
  message.persitenceState = this.persitenceState;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  if (
    this._inReplayMode === true &&
    this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true
  ) {
    this.prepaidInitialBalance =
      parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance =
      parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }

  this.addGameConfigToQueueBase(loadData);

  this.defaultPersistanceData =
    loadData.settings.gameFeatures !== undefined &&
    loadData.settings.gameFeatures.playerState !== undefined &&
    loadData.settings.gameFeatures.playerState.playerState !== undefined
      ? loadData.settings.gameFeatures.playerState.playerState
      : this.defaultPersistanceData;

  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  let message = this._messageQueue[0];

  if (this.defaultPersistanceData === undefined) {
    this.defaultPersistanceData =
      loadData.settings.slotConfig.Config[
        "spinner:GameConfigEvent"
      ].defaultGameState;
  } else {
    this.defaultPersistanceData = JSON.parse(this.defaultPersistanceData.state);
  }
  this.addStartingPersistenceStateQueue();

  gameController.license = loadData.customParameters.license;

  gameData.minimalSpinningTime = loadData.settings.minimalSpinningTime;

  message.buyBonusCostFireball = this.fireballCostMultiplier;
  message.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;
  message.winLinesForCashConversion =
    loadData.settings.slotConfig.Config[
      "spinner:GameConfigEvent"
    ].winLinesForCashConversion;

  message.jackpotsConfig =
    loadData.settings.slotConfig.Config[
      "spinner:GameConfigEvent"
    ].jackpotsConfig;

  message.currency = loadData.settings.currency;

  gameData.recoveryStake = undefined;

  if (loadData.mode === "RESTORE") {
    const data =
      loadData.wagers.data[0].bets[0].eventdata.response.clientData.Parts[0];
    //gameData.miniPot = data.miniJackpotAtGameStart;
    gameData.blazingMultiplierAtGameStart = data.blazingMultiplierAtGameStart;
    gameData.majorJackpotAtGameStart = data.majorJackpotAtGameStart;
    gameData.megaJackpotAtGameStart = data.megaJackpotAtGameStart;
    gameData.ultraJackpotAtGameStart = data.ultraJackpotAtGameStart;
    gameData.minorJackpotAtGameStart = data.minorJackpotAtGameStart;
    gameData.miniJackpotAtGameStart = data.miniJackpotAtGameStart;
  }

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);

    gameData.recoveryStake = stake;

    if (betData.cmd === "LUCKYBET_BUY") {
      gameData.recoveryStake *= gameData.goldenBetMultiplier;
      gameData.encoreEnabled = true;
    } else {
      gameData.encoreEnabled = false;
    }
  }

  gameData.license = loadData.customParameters.license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license = "default";
  }

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes["BONUS_BUY"] ? true : false
  );

  if (message.slotConfig.gameModes.BONUS_BUY_LOW) {
    this.costMultiplierLow =
      message.slotConfig.gameModes.BONUS_BUY_LOW.coinsPerBet / 10;
  }

  if (message.slotConfig.gameModes.BONUS_BUY_HIGH) {
    this.costMultiplierHigh =
      message.slotConfig.gameModes.BONUS_BUY_HIGH.coinsPerBet / 10;
  }

  message.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.processSuperWilds(
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].slotConfig
      .startingSymbols
  );

  message.slotConfig.coins = 10; // purely paytable
};

GatiServer.prototype.addSpinDataToQueueDerived = function (event) {
  var message = {};
  message.type = "spinner:SpinEvent";

  message.panelMultiplier = 1;
  message.uiRandomSeed = event.uiRandomSeed;

  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = event.resultsPanel.symbolsAbove;
  message.resultPanel.symbolsBelow = event.resultsPanel.symbolsBelow;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === "LUCKYBET_BUY") {
      this._inEncore = true;
      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY_LOW") {
      this._inBuyABonus = true;
      this.fireballActive = true;
      this._meta = {
        name: "buyABonusFireBall",
        value: true,
        fireballActive: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY_HIGH") {
      this._inBuyABonus = true;
      this.fireballActive = false;
      this._meta = {
        name: "buyABonusFreeSpins",
        value: true,
        fireballActive: false,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inEncore = stakeData.metaData.encore;
  this.buyBonusHighActive = stakeData.metaData.buyBonusHighActive;

  this.fireballActive =
    stakeData.metaData.fireballActive !== undefined
      ? stakeData.metaData.fireballActive
      : false;

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    //res.baseStake *= 10; // coin for lucky bet is 10x bigger <-- TODO: HB: Keeping this as we might run into issues with golden bet
    this.setDefaultBet(res.baseStake);
  } else if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "BONUS_BUY_HIGH"
  ) {
    this._inBuyABonus = true;
    this.buyBonusHighActive = true;
  } else if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "BONUS_BUY_LOW"
  ) {
    this._inBuyABonus = true;
  }
  return res;
};

GatiServer.prototype.getCheatString = function () {
  return this._latestEngineReponse.wager.bets[0].eventdata.response.clientData
    .Repro;
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
    //delete request.cheat;
  }

  if (this._inEncore) {
    //this._coinValue = 100; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    if (this.buyBonusHighActive) {
      baseStake = stakeController.getBaseStake("BONUS_BUY_HIGH") / 100;
      request.amount = baseStake * this.costMultiplierHigh;
      request.coin = baseStake / this._coinValue;
      this.currentMode = "BonusBuyHigh";
      request.cmd = "BONUS_BUY_HIGH";
    } else {
      baseStake = stakeController.getBaseStake("BONUS_BUY_LOW") / 100;
      request.amount = baseStake * this.costMultiplierLow;
      request.coin = baseStake / this._coinValue;
      this.currentMode = "BonusBuyLow";
      request.cmd = "BONUS_BUY_LOW";
    }
  }
};

GatiServerGame.prototype.addinitialRetriggerToQueue = function () {
  let message = {};
  message.type = "8bof:initialRetrigger";
  this._messageQueue.push(message);
};

GatiServerGame.prototype.updatePersistentState = function (data) {
  this.playerState =
    this._latestEngineReponse.wager.bets[
      this._currentBetData
    ].eventdata.playerState.state;

  if (this.playerState !== undefined) {
    this.playerState = JSON.parse(this.playerState);
  }

  if (
    this._latestEngineReponse.wager.bets[this._currentBetData].eventdata
      .initialPlayerState &&
    !this._isRecoveryGame
  ) {
    const responseIntialPlayerState =
      this._latestEngineReponse.wager.bets[this._currentBetData].eventdata
        .initialPlayerState.state;
    if (responseIntialPlayerState !== undefined) {
      this.initialPlayerState = JSON.parse(responseIntialPlayerState);
    }
  } else {
    this.initialPlayerState = data.InitialGameState
      ? data.InitialGameState
      : this.defaultPersistanceData;
  }

  let versionNum = 0;
  if (this.playerState !== undefined) {
    versionNum = this.playerState.version;
  } else {
    versionNum = this.initialPlayerState;
  }

  this.persitenceState = {
    playerState: this.playerState,
    initialPlayerState: this.initialPlayerState,
    version: versionNum,
  };

  // If this is a bonus buy, then over-ride the intial player state with the bonus buy values.
  // This could properally be a seperate message that over-rides the these values after but this is a good way to piggyback
  // off persistent messages.
  if (data.Mode === 2) {
    const state = this.persitenceState.initialPlayerState;
    state.megaJackpot = data.Parts[0].megaJackpotAtGameStart;
    state.majorJackpot = data.Parts[0].majorJackpotAtGameStart;
    state.ultraJackpot = data.Parts[0].ultraJackpotAtGameStart;
    state.minorJackpot = data.Parts[0].minorJackpotAtGameStart;
    state.miniJackpot = data.Parts[0].miniJackpotAtGameStart;
    state.blazingBountyMultiplier = data.Parts[0].blazingMultiplierAtGameStart;
    state.bonusBuyCeleberation = true;
  }
};

GatiServerGame.prototype.addInitialPersistenceUpdateToQueue = function () {
  var message = {};
  message.type = "8bofBB:PersistenceUpdate-UpdateToInitial";
  message.persitenceState = this.persitenceState;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addEndOfSpinPersistenceUpdateToQueue = function () {
  var message = {};
  message.type = "8bofBB:PersistenceUpdate-UpdateToAfterSpin";
  message.persitenceState = this.persitenceState;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFireballLink) {
    this.getSpinDataFBL(cb);
  } else if (this.inJackpotBonus) {
    this.getSpinDataJackpotBonus(cb);
  } else {
    let parts = data.Parts;
    this._forces = "";

    this.updatePersistentState(data);
    this.addInitialPersistenceUpdateToQueue();

    let totalWon = 0;
    for (let i = 0; i < parts.length; ++i) {
      let type = parts[i].type;
      this.overrideStartingPersistenceValues(parts[i]);

      parts[i].Mode = data.Mode;
      if (type === "baseGame") {
        totalWon += this.getSpinDataNormal(parts[i], data.UIRandomSeed);

        // base game only, game complete
        if (!parts[i].fireballLink.isAwarded) {
          if (!parts[i].jackpotReels.isAwarded) {
            this.addEndOfBaseGameSpinToQueue(
              this.baseGameSpinData.winAmount,
              this.baseGameSpinData.winCapped
            );
            this.addGameCompleteToQueue(totalWon);
          }
        }
      }
    }
    cb();
    this.triggerNextMessage();
  }
};

GatiServerGame.prototype.overrideStartingPersistenceValues = function (data) {
  var message = {};
  message.type = "8bofBB:OverrideStartingPersistenceValues";
  message.blazingMultiplierAtGameStart = data.blazingMultiplierAtGameStart;
  message.majorJackpotAtGameStart = data.majorJackpotAtGameStart;
  message.megaJackpotAtGameStart = data.megaJackpotAtGameStart;
  message.ultraJackpotAtGameStart = data.ultraJackpotAtGameStart;
  message.minorJackpotAtGameStart = data.minorJackpotAtGameStart;
  message.miniJackpotAtGameStart = data.miniJackpotAtGameStart;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (
      sc.isMaxStake() &&
      !this._inReplayMode &&
      !this._inRewatchMode &&
      !this._isPrePaidGame &&
      !isStakeLower
    ) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= gameData.goldenBetMultiplier;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.getFireballIdFromCash = function (fireball) {
  const symbols = resourceManager.getConfiguration().symbols;
  const firstCashFireballId = symbols["Symbol_Fireball10"].ID;
  const possibleValues = [
    10, 20, 30, 40, 50, 100, 150, 200, 250, 500, 1000, 2000, 5000,
  ];

  // base stake is good for both base game and golden bet
  let stakeController = resourceManager.getController("stakeController");
  let stake = stakeController.getBaseStake("default");

  if (this._inBuyABonus) {
    stake = stakeController.getBaseStake(
      !this.buyBonusHighActive ? "BONUS_BUY_LOW" : "BONUS_BUY_HIGH"
    );
  }

  const stakeIndependentValue =
    fireball.amount / (stake / gameData.gameConfig.winLinesForCashConversion);
  const index = possibleValues.indexOf(stakeIndependentValue);
  if (index >= 0) {
    return firstCashFireballId + index;
  }

  return -1;
};

GatiServerGame.prototype.getFireballIdFromPot = function (fireball) {
  const symbols = resourceManager.getConfiguration().symbols;
  const firstPotFireballId = symbols["Symbol_FireballMini"].ID;
  const possibleValues = ["Mini", "Minor", "Major", "Ultra", "Mega"];
  const index = possibleValues.indexOf(fireball.potName);
  if (index >= 0) {
    return firstPotFireballId + index;
  }
  return -1;
};

GatiServerGame.prototype.getFireballId = function (fireball) {
  const symbols = resourceManager.getConfiguration().symbols;
  switch (fireball.type) {
    case "Cash": {
      return this.getFireballIdFromCash(fireball);
    }
    case "Pot": {
      return this.getFireballIdFromPot(fireball);
    }
    case "ExtraHot":
      return symbols["Symbol_FireballExtraHot"].ID;
    case "BlazingBounty":
      return symbols["Symbol_FireballBlazingBounty"].ID;
    case "RespinPlus": {
      return symbols["Symbol_FireballRespinPlus"].ID;
    }
    default: {
      return symbols["Symbol_Fireball10"].ID;
    }
  }
  return -1;
};

GatiServerGame.prototype.convertFireballIds = function (spinEvent, fireballs) {
  const self = this;
  fireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const id = self.getFireballId(fireball);
    spinEvent.resultsPanel.reelList[reel].symbols[row].value = id;
  });
};

GatiServerGame.prototype.getPrizeDataFromFireball = function (fireball) {
  let prizeData = { type: fireball.type };
  switch (fireball.type) {
    case "Cash":
    case "WildCash": {
      prizeData.value = fireball.amount;
      break;
    }
    case "Pot":
    case "WildPot": {
      prizeData.potName = fireball.potName;
      prizeData.value = fireball.potValue;
      break;
    }
    case "Multiplier":
    case "WildMultiplier": {
      prizeData.value = fireball.multiplier;
      break;
    }
    default: {
      prizeData.type = "Cash";
      prizeData.value = fireball.amount;
    }
  }
  return prizeData;
};

GatiServerGame.prototype.addFireballLinkStartToQueue = function (data) {
  const startingFireballs = data.stopWindowFireballs;
  const onEntryEvents = data.fireballLink.onEntryEvents;
  var message = {};
  message.type = "8bofBB:FireballLinkStartEvent";

  const self = this;
  message.startingFireballs = [];
  startingFireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const symbolId = self.getFireballId(fireball);
    const prizeData = self.getPrizeDataFromFireball(fireball);
    message.startingFireballs.push({ reel, row, symbolId, prizeData });
  });
  message.livesRemaining = data.fireballLink.startingNumberOfLives;
  message.onEntryEvents = onEntryEvents;
  message.winCapped = data.fireballLink.winCapped;
  if (data.fireballLink.winCapped) {
    message.winCappedAmount = this.fireballLinkTotalWin;
  }

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballLinkDataToQueue = function (spin) {
  const symbolsLanded = spin.spinTo;
  const events = spin.events;
  const blanks = [];
  const newFireballs = [];
  for (let index = 0; index < symbolsLanded.length; index++) {
    const symbol = symbolsLanded[index];
    if (symbol.type === "Blank") {
      blanks.push(symbol);
    } else {
      newFireballs.push(symbol);
    }
  }

  var message = {};
  message.type = "8bof:FireballLinkDataEvent";

  const self = this;
  message.allSymbolsLanded = symbolsLanded;
  message.blanks = blanks;
  message.newFireballs = [];
  newFireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const symbolId = self.getFireballId(fireball);
    const prizeData = self.getPrizeDataFromFireball(fireball);

    message.newFireballs.push({ reel, row, symbolId, prizeData });
  });
  message.events = events;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballLinkEndToQueue = function (win) {
  var message = {};
  message.type = "8bof:FireballLinkEndEvent";
  message.winAmount = win;

  for (let index = 0; index < this.fireballLinkEndEvents.length; index++) {
    const event = this.fireballLinkEndEvents[index];
    if (event.type === "BlazingMultiplierChangedEvent") {
      event.type = "ResetBlazingMultiplierEvent";
    }
  }

  message.endGameEvents = this.fireballLinkEndEvents;

  this._messageQueue.push(message);

  //At the end of a firelink we want to pause the execution regardless.

  if (this.baseGameSpinData.jackpotBoost.isAwarded) {
    this.addFireballsLandedToQueue(
      [...this.baseGameSpinData.stopWindowFireballs],
      this.baseGameSpinData.jackpotReels.isAwarded,
      true
    );
    this.addJackpotToQueue(
      this.baseGameSpinData,
      true //we want to pause execution regardless
    );
  } else {
    this.addFireballsLandedToQueue(
      [...this.baseGameSpinData.stopWindowFireballs],
      this.baseGameSpinData.jackpotReels.isAwarded,
      false
    );
  }
};

GatiServerGame.prototype.addJackpotBonusStartToQueue = function (data) {
  const startingStopWindow = {
    reelList: [
      { symbols: [17, 17, 17] },
      { symbols: [17, 17, 17] },
      { symbols: [17, 17, 17] },
    ],
    reels: 3,
    symbolsAbove: undefined,
    symbolsBelow: undefined,
  };

  var message = {};
  message.type = "8bofBB:JackpotBonusStartEvent";
  message.stopWindow = startingStopWindow;
  message.winAmount = data.jackpotReels.winAmount;
  message.winCapped = data.jackpotReels.winCapped;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addJackpotBonusDataToQueue = function (spin) {
  const blanks = [];
  const newFireballs = [];
  // for (let index = 0; index < symbolsLanded.length; index++) {
  //   const symbol = symbolsLanded[index];
  //   if (symbol.type === "Blank") {
  //     blanks.push(symbol);
  //   } else {
  //     newFireballs.push(symbol);
  //   }
  // }

  var message = {};
  message.type = "8bofBB:JackpotBonusDataEvent";

  const self = this;
  message.stopWindow = spin.stopWindow;
  message.blanks = blanks;
  message.fireballs = [];
  spin.coins.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const symbolId = self.getFireballId(fireball);
    const prizeData = self.getPrizeDataFromFireball(fireball);

    message.fireballs.push({ reel, row, symbolId, prizeData });
  });
  message.symbolAwards = spin.symbolAwards;
  message.finalSpin = this.jackpotBonusCount >= this.jackpotBonusSpins.length;

  //Add coords to Symbol data..
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addJackpotBonusEndToQueue = function (win) {
  var message = {};
  message.type = "8bofBB:JackpotBonusEndEvent";
  message.winAmount = win;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballsLandedToQueue = function (
  fireballs,
  isJackpotComingUp,
  doesBoostTrigger
) {
  var message = {};
  message.type = "8bofBB:FireballsLandedEvent";
  message.fireballs = fireballs;
  message.pauseExecution = !doesBoostTrigger;
  message.isJackpotComingUp = isJackpotComingUp;
  //  message.pauseExecution = pauseExecution;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addPotBonusStartToQueue = function (
  potWon,
  sequence,
  winAmount
) {
  var message = {};
  message.type = "8bof:PotBonusStartEvent";
  message.potWon = potWon;
  message.sequence = sequence;
  message.winAmount = winAmount;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.checkForSuperWildOnReel = function (
  symbols,
  start,
  count
) {
  const sWild = 9;
  let allSWilds = true;
  for (let row = start; row < start + count; ++row) {
    if (symbols[row].value != sWild) {
      allSWilds = false;
    }
  }
  return allSWilds;
};

GatiServerGame.prototype.replaceSuperWildOnReel = function (
  symbols,
  start,
  count,
  symbolId
) {
  for (let row = start; row < start + count; ++row) {
    symbols[row].value = symbolId;
  }
};

GatiServerGame.prototype.processSuperWilds = function (reelList) {
  const sWild_x2 = 42;
  const sWild_x3 = 43;
  for (let reel = 0; reel < reelList.length; ++reel) {
    if (this.checkForSuperWildOnReel(reelList[reel].symbols, 0, 3)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 0, 3, sWild_x3);
    } else if (this.checkForSuperWildOnReel(reelList[reel].symbols, 0, 2)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 0, 2, sWild_x2);
    } else if (this.checkForSuperWildOnReel(reelList[reel].symbols, 1, 2)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 1, 2, sWild_x2);
    }
  }
};

GatiServerGame.prototype.processSuperWildWins = function (
  winningLinesEvent,
  reelList
) {
  for (let line = 0; line < winningLinesEvent.winningLines.length; ++line) {
    for (
      let id = 0;
      id < winningLinesEvent.winningLines[line].symbol.ids.length;
      ++id
    ) {
      if (winningLinesEvent.winningLines[line].symbol.ids[id] === 9) {
        const reel = winningLinesEvent.winningLines[line].positions[id].reel;
        const row = winningLinesEvent.winningLines[line].positions[id].row;

        winningLinesEvent.winningLines[line].symbol.ids[id] =
          reelList[reel].symbols[row].value;
      }
    }
  }
};

GatiServerGame.prototype.addEndOfBaseGameSpinToQueue = function (
  totalWin,
  isCapped
) {
  var message = {};
  message.type = "8bof:EndOfBaseGameSpinEvent";
  message.totalWin = totalWin;
  message.isCapped = isCapped;
  this._messageQueue.push(message);
  this.addEndOfSpinPersistenceUpdateToQueue();
};

GatiServerGame.prototype.addBlazingMultiplierToQueue = function (data) {
  var message = {};
  message.type = "8bofbb:BlazingMultiplier";
  message.multiplier = data.blazingMultiplierAdd.multiplier;
  message.multiplierId = data.blazingMultiplierAdd.multiplierId;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataNormal = function (data, UIRandomSeed) {
  const spinEvent = {
    resultsPanel: data.stopWindow,
  };

  const winningLinesEvent = data.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  this.convertFireballIds(spinEvent, data.stopWindowFireballs);
  this.addSpinDataToQueue(spinEvent);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.fireballLink = data.fireballLink;
  message.uiRandomSeed = UIRandomSeed;

  this.processSuperWilds(spinEvent.resultsPanel.reelList);

  const spinMessage = this._messageQueue[this._messageQueue.length - 1];
  spinMessage.isFbl = data.fireballLink.isAwarded;
  //spinMessage.isPotBonus = data.potPick;
  spinMessage.isPrePaidGame = this._isPrePaidGame;
  spinMessage.totalWinnings = data.winAmount;
  const reelList = spinEvent.resultsPanel.reelList;
  let allWilds = true;
  const reelsWithStackedWilds = [];

  for (let reel = 0; reel < reelList.length && data.Mode !== 2; ++reel) {
    if (reelList[reel].symbols[0].value !== 43) {
      allWilds = false;
    } else {
      reelsWithStackedWilds.push(reel);
    }
  }

  if (data.stackedWildReelSetsUsed && data.Mode !== 2) {
    spinMessage.isWildFire = true;
  }
  spinMessage.reelsWithStackedWilds = reelsWithStackedWilds;

  if (
    winningLinesEvent.totalLineWinnings > 0 &&
    winningLinesEvent.winningLines.length > 0
  ) {
    this.processSuperWildWins(
      winningLinesEvent,
      spinEvent.resultsPanel.reelList
    );
    this.addWinningsToQueue(winningLinesEvent);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.winIsCapped = data.winCapped;
  }

  if (data.blazingMultiplierAdd.isAdded) {
    this.addBlazingMultiplierToQueue(data);
  }

  if (data.fireballLink.isAwarded) {
    this.inFireballLink = true;
    this.fireballLinkCount = 0;
    this.fireballLinkSpins = data.fireballLink.spins;
    this.fireballLivesMax = 3;
    this.fireballLinkTotalWin = data.fireballLink.winAmount;
    this.fireballLinkEndEvents = data.fireballLink.endGameEvents;
    this.addFireballLinkStartToQueue(data);
  } else if (data.jackpotBoost.isAwarded) {
    this.addFireballsLandedToQueue(
      [...data.stopWindowFireballs],
      data.jackpotReels.isAwarded,
      true
    );
    this.addJackpotToQueue(data, data.jackpotReels.isAwarded);
  } else {
    this.addFireballsLandedToQueue(
      [...data.stopWindowFireballs],
      data.jackpotReels.isAwarded,
      !data.jackpotReels.isAwarded
    );
  }

  if (data.volcanoAdd.isAdded && !data.fireballLink.isAwarded) {
    this.addVolcanoAddToQueue(data);
  }

  if (data.jackpotReels.isAwarded) {
    this.inJackpotBonus = true;
    this.jackpotBonusCount = 0;
    this.jackpotBonusSpins = data.jackpotReels.spins;
    this.jackpotBonusTotalWin = data.jackpotReels.winAmount;
    if (!data.fireballLink.isAwarded) {
      this.addJackpotBonusStartToQueue(data);
    }
  }

  if (
    data.volcanoReset.isReset &&
    !data.fireballLink.isAwarded &&
    !data.jackpotReels.isAwarded
  ) {
    this.addVolcanoResetToQueue(data);
  }

  this.baseGameSpinData = data;
  // if (!data.fireballLink.isAwarded) {
  //   if (!data.jackpotReels.isAwarded) {
  //     this.finishSpin(data);
  //   }
  // }

  return data.winAmount;
};

GatiServerGame.prototype.addVolcanoAddToQueue = function (data) {
  var message = {};
  message.type = "8bofbb:VolcanoAdd";
  message.newSize = data.volcanoAdd.newSize;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addVolcanoResetToQueue = function (data) {
  var message = {};
  message.type = "8bofbb:VolcanoReset";
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addJackpotToQueue = function (
  data,
  isJackpotComingUp
) {
  var message = {};
  message.type = "8bofbb:JackpotBoost";
  message.boosts = data.jackpotBoost.boosts;
  message.pauseExecution = isJackpotComingUp;
  //  message.pauseExecution = pauseExecution;

  // amount: 5;
  // jackpotSymbol: "Minor";
  // newValue: 105;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataFBL = function (cb) {
  const thisOutcome = this.fireballLinkSpins[this.fireballLinkCount];

  if (this.fireballLinkCount < this.fireballLinkSpins.length) {
    ++this.fireballLinkCount;
    this.checkOutcomeEvents(thisOutcome);

    this.addFireballLinkDataToQueue(thisOutcome);
  } else {
    this.addFireballLinkEndToQueue(this.fireballLinkTotalWin);
    this.inFireballLink = false;
    if (this.baseGameSpinData.volcanoAdd.isAdded) {
      this.addVolcanoAddToQueue(this.baseGameSpinData);
    }

    if (
      !this.inJackpotBonus ||
      this.jackpotBonusCount >= this.jackpotBonusSpins.length
    ) {
      if (this.baseGameSpinData.volcanoReset.isReset) {
        this.addVolcanoResetToQueue(this.baseGameSpinData);
      }
      this.inJackpotBonus = false;
      this.addEndOfBaseGameSpinToQueue(
        this.baseGameSpinData.winAmount,
        this.baseGameSpinData.winCapped
      );
      this.addGameCompleteToQueue(0);
    } else {
      this.inFireballLink = false;
      this.addJackpotBonusStartToQueue(this.baseGameSpinData);
    }
  }
  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.checkOutcomeEvents = function (data) {
  const hasMaxLivesRemainingChanged = data.events.some(
    (event) => event.type === "MaximumLivesIncreasedEvent"
  );

  const hasLivesRemainingChanged = data.events.some(
    (event) => event.type === "LivesRemainingChangedEvent"
  );

  // If we don't have a lives remaining changed event or have one AFTER a Max Lives update. Create one.
  if (
    !hasLivesRemainingChanged ||
    (hasLivesRemainingChanged && hasMaxLivesRemainingChanged)
  ) {
    for (let i = 0; i < data.spinTo.length; ++i) {
      const type = data.spinTo[i].type;
      if (
        type === "Cash" ||
        type === "ExtraHot" ||
        type === "BlazingBounty" ||
        type === "RespinPlus"
      ) {
        data.events.unshift({
          type: "LivesRemainingChangedEvent",
          newLivesRemaining: this.fireballLivesMax,
        });
        break;
      }
    }
  }

  // Move the existing LivesRemaining Event to the front because we want to process it first.
  if (hasLivesRemainingChanged && !hasMaxLivesRemainingChanged) {
    for (let i = 0; i < data.events.length; ++i) {
      const type = data.events[i].type;
      if (type === "LivesRemainingChangedEvent") {
        data.events.unshift(data.events.splice(i, 1)[0]);
        break;
      }
    }
  }

  // Handles the maxium lives updating.
  for (let i = 0; i < data.spinTo.length; ++i) {
    if (data.spinTo[i].type === "RespinPlus") {
      this.fireballLivesMax++;
    }
  }
  if (hasMaxLivesRemainingChanged) {
    for (let i = 0; i < data.spinTo.length; ++i) {
      if (
        data.spinTo[i].type === "Cash" ||
        data.spinTo[i].type === "ExtraHot" ||
        data.spinTo[i].type === "BlazingBounty"
      ) {
        data.events.push({
          type: "LivesRemainingChangedEvent",
          newLivesRemaining: this.fireballLivesMax,
        });
        break;
      }
    }
  }
};

GatiServerGame.prototype.getSpinDataJackpotBonus = function (cb) {
  const thisOutcome = this.jackpotBonusSpins[this.jackpotBonusCount];

  if (this.jackpotBonusCount < this.jackpotBonusSpins.length) {
    ++this.jackpotBonusCount;
    this.addJackpotBonusDataToQueue(thisOutcome);
  } else {
    this.addJackpotBonusEndToQueue(this.jackpotBonusTotalWin);
    this.inJackpotBonus = false;

    //this.finishSpin(this.baseGameSpinData);
    if (this.baseGameSpinData.volcanoReset.isReset) {
      this.addVolcanoResetToQueue(this.baseGameSpinData);
    }
    this.addEndOfBaseGameSpinToQueue(
      this.baseGameSpinData.winAmount,
      this.baseGameSpinData.winCapped
    );
    this.addGameCompleteToQueue(0);
  }
  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addDemotionsToQueue = function (demotions) {
  var message = {};
  message.type = "8bof:Demotions";
  message.demotions = demotions;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballAwardsToQueue = function (awards) {
  var message = {};
  message.type = "8bof:FireballAwards";
  message.fireballAwards = awards;

  this._messageQueue.push(message);
};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

// replace the libs endGame function so we can update the _endGame vars
GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};
